import {useCallback, useRef} from "react";

export function useInfiniteScroll(loading, listLength, listTotalSize, pageSize, setPageIndex) {
    const observer = useRef()
    const lastElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && listLength <= listTotalSize) {
                setPageIndex(prev => (listTotalSize / pageSize) >= prev ? prev + 1 : prev)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading])

    return lastElementRef
}